/* hc-guarantee.js - script de sections/satisfaction-guarantee.liquid, externalise le 19-08-2026 (defer). */
function scrollToProduct(event) {
  event.preventDefault();

  // Find the first product section on the page
  const productSection = document.querySelector('.shop-add-to-cart-button, button[name="add"], product-form, .product-form, .shopify-section .product, .shopify-section [data-section-type="product"], main#MainContent .product-template, main#MainContent .product, #ProductSection, #shopify-section-product-template, .product-section');

  if (productSection) {
    // Scroll to the product section
    productSection.scrollIntoView({
      behavior: 'smooth',
      block: 'center'
    });
  } else {
    // Fallback: just scroll to top if product section not found
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }

  return false;
}